import {GetCookieInfo} from "./CookieManager";

const DecodeJwt = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const decodedPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );

        return JSON.parse(decodedPayload);
    } catch (error) {
        console.error('Error decoding JWT:', error);
        return null;
    }
}

export const GetRole = () => {
    try {
        const cookieInfo = GetCookieInfo('nplt');
        return DecodeJwt(cookieInfo.value).typ;
    } catch (error) {
        console.error('Error getting role:', error);
        return null;
    }
}

export const GetIsBlocked = () => {
    try {
        const cookieInfo = GetCookieInfo('nplt');
        return DecodeJwt(cookieInfo.value).sub;
    } catch (error) {
        console.error('Error getting role:', error);
        return null;
    }
}